import { Component, EventEmitter, Input, Output } from '@angular/core';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface TriggerSubject {}

@Component({
  selector: 'sales-ui-meddic-errors',
  templateUrl: './meddic-errors.component.html',
  styleUrls: ['./meddic-errors.component.scss'],
  standalone: false,
})
export class MeddicErrorsComponent {
  @Input() hasError: boolean;
  @Input() retrying: boolean;
  @Input() errorMessage: string;

  @Output() retryRequest = new EventEmitter<TriggerSubject>();

  emitRetryEvent(): void {
    this.retryRequest.emit();
  }
}
